import React from 'react';
import { Box, Text } from '@chakra-ui/react';

export type TimelineItemProps = {
  title: React.ReactNode;
  timestamp: number;
};

const TimelineItem: React.FC<TimelineItemProps> = ({
  title,
  timestamp,
  children,
}) => (
  <Box pl="5px">
    <Box
      position="relative"
      borderLeftWidth="2px"
      borderLeftColor="dark.600"
      borderLeftStyle="solid"
      pl="6"
    >
      <Box
        position="absolute"
        left="-6px"
        top="2"
        w="10px"
        h="10px"
        rounded="full"
        bg="secondary.400"
        outline="10px solid"
        outlineColor="dark.900"
      />

      <Text fontWeight="semibold" isTruncated>
        {title}
      </Text>

      <Box
        fontSize="xs"
        color="bright.500"
        css={{
          span: {
            color: 'var(--chakra-colors-secondary-400)',
          },
        }}
      >
        {children}
      </Box>

      <Text
        fontSize="xs"
        fontWeight="normal"
        opacity="0.6"
        isTruncated
        mt="1.5"
      >
        {new Date(timestamp * 1000).toLocaleString()}
      </Text>
    </Box>
  </Box>
);

export default TimelineItem;
